import UserLinkByText from './components/UserLinkByText'

export default {
  components: {
    UserLinkByText
  }
}